import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import Conversation from '../../chat/chat-components/Conversation';
import Drawer from '../../../../../components-new/ui/Drawer';
import SilverButton from '../../../../../components-new/buttons/SilverButton';
import XIcon from '../../../../../assets/icons/XIcon';
import Translate from '../../../../../components/Translate';
import './ConversationHistory.css';

const ConversationHistory = ({
                                 conversation, loadOlderMessages, user, tariff, company,
                                 isOpen = true, closeWindow
                             }) => {
    const [drawerOpen, setDrawerOpen] = useState(isOpen);
    const closeTimerRef = useRef(null);

    useEffect(() => {
        if (isOpen) setDrawerOpen(true);
    }, [isOpen]);

    useEffect(() => () => clearTimeout(closeTimerRef.current), []);

    const requestClose = () => {
        if (closeTimerRef.current) return;
        setDrawerOpen(false);
        closeTimerRef.current = setTimeout(closeWindow, 300);
    };

    return (
        <Drawer
            open={drawerOpen}
            onClose={requestClose}
            side="right"
            width={720}
            className="conversation-history-drawer"
            overlayClassName="conversation-history-drawer-overlay"
            paperStyle={{maxWidth: 'calc(100vw - 16px)'}}
        >
            <div className="conversation-history-drawer__shell">
                <div className="conversation-history-drawer__header">
                    <span><Translate text="chatHistory"/></span>
                    <SilverButton type="button" variant="ghost" iconOnly expandedHover width="20px" height="20px"
                                  onClick={requestClose}>
                        <XIcon width={20} height={20} stroke="currentColor"/>
                    </SilverButton>
                </div>
                <div className="conversation-history-drawer__content">
                <Conversation conversation={conversation}
                              loadOlderMessages={loadOlderMessages}
                              user={user}
                              readOnly
                              fromUnmanagedList={false}
                              showSideBar={false}
                              hasBackButton={false}
                              tariff={tariff || (company && company.tariff)}
                              company={company}
                              isConversationHistory={true}
                />
                </div>
            </div>
        </Drawer>
    );
};

ConversationHistory.propTypes = {
    conversation: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    loadOlderMessages: PropTypes.func.isRequired,
    closeWindow: PropTypes.func.isRequired,
    isOpen: PropTypes.bool,
};

export default ConversationHistory;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/history/ConversationHistory.jsx